var _style, _path, _path2, _path3, _path4, _polygon, _polygon2, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoCasa2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 283.5 283.5",
    style: {
      enableBackground: "new 0 0 283.5 283.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#ED1C24;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:#FFED00;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M174.8,193.3l-56.5,0.1c-12.7,0-23.1-10.4-23.2-23.1l-0.1-56.4c0-12.7,10.4-23.1,23.1-23.2l56.5-0.1 c12.7,0,23.1,10.4,23.2,23.1l0.1,56.4C197.9,182.8,187.5,193.3,174.8,193.3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M146.6,146c-5.5,0-10-4.5-10-10c0-5.5,4.5-10,10-10c5.5,0,10,4.5,10,10C156.6,141.6,152.1,146,146.6,146  M146.6,124.6c-6.3,0-11.4,5.1-11.4,11.4c0,6.3,5.1,11.4,11.4,11.4c6.3,0,11.4-5.1,11.4-11.4C158,129.7,152.9,124.6,146.6,124.6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M155.6,129.6l-1.9,2.7l0.7,4.4l2.9,3.3C157.3,140,159.1,133.5,155.6,129.6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M136.2,133.8l3.7,1.7l1.2,4.8l-3.2,2.8C137.9,142.9,134.3,138.3,136.2,133.8"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "144.5,141.5 146.8,144.8 151.5,143.3 153.1,139.2 148.6,137.7 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "143.1,128.8 142.6,133.2 147.5,135 151.1,131.4 148.4,127.9 "
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M181.4,118.3c-0.6-2.6-1.7-5-3.7-6.8c-2.6-2.4-5.9-3.5-9.3-4c-4.7-0.7-10.1-0.4-15-0.5l-1.7,11.9 c2.2,0,5.3,0,7.4,0c0.9,0,1.8,0.1,2.7,0.3c1.4,0.4,2.4,1.2,2.8,2.6c0.5,1.6,0.4,3.3,0.2,4.9c-0.4,3.3-0.8,6.7-1.3,10 c-0.6,3.7-1.1,7.5-1.9,11.2c-0.7,3.4-2.8,5.1-6.3,5.2c-2.7,0.1-3.8,0.1-8.4,0.1l-3.7,26.5l-0.5-0.1c0,0.1,0,0.1,0,0.1 c2,0,5.3,0,7.2,0c2.1,0,4.3,0,6.4,0c0.7,0,1-0.2,1.1-0.9c0.6-4.4,1.3-8.9,1.9-13.3c0.1-0.6,0.4-0.8,0.9-0.9c1.3-0.2,2.5-0.5,3.7-0.8 c4.1-1.1,7.5-3.2,10.1-6.5c3.2-4.1,4.6-9,5.3-14.1c0.6-4,1.1-8,1.7-12.1C181.9,126.9,182.4,122.6,181.4,118.3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M141.1,153.3c-2.6,0-6.1,0-8.6-0.1c-2.6-0.1-4.4-1.5-4.5-3.7c-0.1-2-0.1-4,0.1-5.9c0.3-3,0.8-5.9,1.2-8.8 c0.5-3.4,1-6.9,1.7-10.3c0.8-3.8,3.1-5.4,6.9-5.5c2.5,0,5.1,0,7.6,0c0.1,0,0.3,0,0.4,0l1.7-11.9h-0.5c-2.7,0-5.4,0-8.1,0 c-3.3,0-6.6,0.3-9.8,1.1c-4.4,1.2-8.1,3.4-10.8,7.1c-2.7,3.7-4,7.9-4.7,12.3c-0.8,5-1.4,10.1-2.1,15.1c-0.5,3.8-0.7,7.6,0.1,11.4 c0.6,2.6,1.8,4.8,3.7,6.6c2.1,1.9,4.6,2.9,7.4,3.6c3.5,0.8,7,0.9,10.5,0.8c1.7,0,4.5,0,6.3,0L141.1,153.3z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoCasa2);
export default __webpack_public_path__ + "static/media/logo_casa_2.c2ada2544c8df68a40f6347cd688e95c.svg";
export { ForwardRef as ReactComponent };